import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { BRAND, whatsappLink } from '../data/brand';

export default function About() {
  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle
        title={`About ${BRAND.name}`}
        breadcrumbs={[{ label: 'About' }]}
      />

      {/* Who we are */}
      <section style={{ padding: '64px 0' }}>
        <div className="auto-container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div
                style={{
                  position: 'relative',
                  paddingBottom: 48,
                  paddingRight: 40,
                }}
              >
                <img
                  src="/images/hb/exterior/exterior-front.jpg"
                  alt={BRAND.name}
                  style={{
                    width: '100%',
                    height: 420,
                    objectFit: 'cover',
                    borderRadius: 6,
                    display: 'block',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    right: 0,
                    width: '52%',
                    borderRadius: 6,
                    overflow: 'hidden',
                    border: '4px solid #fff',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                  }}
                >
                  <img
                    src="/images/hb/exterior/exterior-side.jpg"
                    alt="Hotel Grounds"
                    style={{
                      width: '100%',
                      height: 180,
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <span className="h2-label">About Us</span>
              <h2
                style={{
                  fontFamily: 'var(--gw-font-h,serif)',
                  fontSize: 'clamp(28px,3.5vw,46px)',
                  color: '#111',
                  lineHeight: 1.15,
                  margin: '10px 0 18px',
                }}
              >
                Imo's Landmark
                <br />
                of Hospitality Excellence
              </h2>
              <p
                style={{
                  color: '#555',
                  fontSize: 15,
                  lineHeight: 1.85,
                  marginBottom: 16,
                }}
              >
                {BRAND.name} is located at {BRAND.addressLines[0]},{' '}
                {BRAND.addressLines[1]}, {BRAND.city} — one of the most
                prestigious hospitality destinations on the Imo Marina
                waterfront.
              </p>
              <p
                style={{
                  color: '#555',
                  fontSize: 15,
                  lineHeight: 1.85,
                  marginBottom: 24,
                }}
              >
                Set against sweeping views of the lagoon, we offer world-class
                rooms across seven categories, a rooftop swimming pool, premium
                bar, professional boardroom and a magnificent event hall under
                one roof.
              </p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 9,
                  marginBottom: 28,
                }}
              >
                {[
                  '7 room categories: Classic, Standard, Deluxe, Premium, Executive & Suites',
                  'Rooftop pool, bar, boardroom and event hall on-site',
                  '24-hour power supply, security and reception — every day',
                  'Free high-speed WiFi throughout the entire property',
                  'Free secure parking — ample space for guests',
                ].map((p, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      gap: 10,
                      fontSize: 14,
                      color: '#444',
                      alignItems: 'flex-start',
                    }}
                  >
                    <i
                      className="fas fa-circle-check"
                      style={{ color: '#b08d57', marginTop: 3, flexShrink: 0 }}
                    ></i>
                    <span>{p}</span>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <Link to="/rooms" className="h2-btn-primary">
                  View Room Tariff
                </Link>
                <Link to="/contact" className="h2-btn-ghost">
                  Make a Reservation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Photo strip */}
      <section style={{ padding: '0 0 64px' }}>
        <div className="auto-container">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4,1fr)',
              gap: 10,
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            {[
              {
                img: '/images/hb/facilities/reception-staff.jpg',
                label: 'Reception',
              },
              {
                img: '/images/hb/facilities/swimming-pool.jpg',
                label: 'Swimming Pool',
              },
              {
                img: '/images/hb/facilities/event-hall.jpg',
                label: 'Event Hall',
              },
              {
                img: '/images/hb/facilities/boardroom.jpg',
                label: 'Boardroom',
              },
            ].map((f, i) => (
              <div
                key={i}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  height: 220,
                }}
              >
                <img
                  src={f.img}
                  alt={f.label}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.5s',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.32)',
                    display: 'flex',
                    alignItems: 'flex-end',
                    padding: 14,
                  }}
                >
                  <span
                    style={{
                      color: '#fff',
                      fontSize: 13,
                      fontWeight: 700,
                      letterSpacing: 1,
                    }}
                  >
                    {f.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats + contact */}
      <section style={{ background: '#111827', padding: '56px 0' }}>
        <div className="auto-container">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4,1fr)',
              gap: 0,
              marginBottom: 48,
              borderBottom: '1px solid rgba(255,255,255,0.08)',
              paddingBottom: 40,
            }}
          >
            {[
              { num: '7', suf: '', label: 'Room Categories' },
              { num: '1500', suf: '+', label: 'Happy Guests' },
              { num: '24', suf: '/7', label: 'Reception Open' },
              { num: '5', suf: '', label: 'Major Facilities' },
            ].map((s, i) => (
              <div
                key={i}
                style={{
                  textAlign: 'center',
                  borderRight:
                    i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                }}
              >
                <div
                  style={{
                    fontSize: 52,
                    fontWeight: 700,
                    color: '#fff',
                    fontFamily: 'var(--gw-font-h,serif)',
                    lineHeight: 1,
                  }}
                >
                  {s.num}
                  <span style={{ color: '#b08d57' }}>{s.suf}</span>
                </div>
                <div
                  style={{
                    fontSize: 11,
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    color: 'rgba(255,255,255,0.45)',
                    marginTop: 8,
                  }}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 20,
            }}
          >
            <div>
              <div
                style={{
                  color: 'rgba(255,255,255,0.5)',
                  fontSize: 12,
                  marginBottom: 4,
                }}
              >
                Location
              </div>
              <div style={{ color: '#fff', fontSize: 14, maxWidth: 480 }}>
                {BRAND.addressLines.join(', ')}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a
                href={`tel:${BRAND.phones[0].tel}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '10px 18px',
                  background: 'rgba(255,255,255,0.08)',
                  color: '#fff',
                  borderRadius: 3,
                  textDecoration: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <i className="fas fa-phone" style={{ color: '#b08d57' }}></i>
                {BRAND.phones[0].label}
              </a>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  padding: '10px 18px',
                  background: '#25d366',
                  color: '#fff',
                  borderRadius: 3,
                  textDecoration: 'none',
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                <i className="fab fa-whatsapp"></i>WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
